module.exports = __webpack_public_path__ + "static/media/color1.b2b23228.PNG";